/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { BrokerageOrderResource } from '../model/models';
import { BrokerageResource } from '../model/models';
import { BrokerageTipResource } from '../model/models';
import { ExtraResource } from '../model/models';
import { InlineObject } from '../model/models';
import { InlineObject1 } from '../model/models';
import { InvoiceResource } from '../model/models';
import { OverviewResource } from '../model/models';
import { RateResource } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface WageServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Wages agree
     * 
     * @param month 
     * @param year 
     * @param userId 
     * @param auto 
     */
    wagesAgree(month: number, year: number, userId: number, auto?: boolean, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Wages brokerage
     * 
     * @param month 
     * @param year 
     * @param userId 
     * @param companyId 
     */
    wagesBrokerage(month: number, year: number, userId: number, companyId: number, extraHttpRequestParams?: any): Observable<BrokerageResource>;

    /**
     * Wages brokerage detail ORDER
     * 
     * @param storeId 
     * @param month 
     * @param year 
     * @param userId 
     * @param companyId 
     */
    wagesBrokerageDetailOrder(storeId: number, month: number, year: number, userId: number, companyId: number, extraHttpRequestParams?: any): Observable<BrokerageOrderResource>;

    /**
     * Wages brokerage detail TIP
     * 
     * @param storeId 
     * @param month 
     * @param year 
     * @param userId 
     * @param companyId 
     */
    wagesBrokerageDetailTip(storeId: number, month: number, year: number, userId: number, companyId: number, extraHttpRequestParams?: any): Observable<BrokerageTipResource>;

    /**
     * Wages extra
     * 
     * @param month 
     * @param year 
     * @param userId 
     * @param companyId 
     */
    wagesExtra(month: number, year: number, userId: number, companyId: number, extraHttpRequestParams?: any): Observable<ExtraResource>;

    /**
     * Wages invoice download
     * 
     * @param invoiceId 
     */
    wagesInvoiceDownload(invoiceId: number, extraHttpRequestParams?: any): Observable<object>;

    /**
     * Wages invoices
     * 
     * @param month 
     * @param year 
     * @param userId 
     * @param companyId 
     */
    wagesInvoices(month: number, year: number, userId: number, companyId: number, extraHttpRequestParams?: any): Observable<InvoiceResource>;

    /**
     * Wages overview
     * 
     * @param month 
     * @param year 
     * @param userId 
     */
    wagesOverview(month: number, year: number, userId: number, extraHttpRequestParams?: any): Observable<OverviewResource>;

    /**
     * Wages rate
     * 
     */
    wagesRate(extraHttpRequestParams?: any): Observable<RateResource>;

}
